// Auto-generated by tools/generate-version.js. Do not edit or commit.
export const appVersion = '1.0.0-74c3b2ab';
